import { useMemo } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { resolveAccess, type AccessState } from './access';

/** Единственная точка чтения состояния доступа во всём приложении (BILL-1). */
export function useAccess(): AccessState {
  const { user, isAccessResolved } = useAuth();
  return useMemo(() => resolveAccess(user, isAccessResolved), [user, isAccessResolved]);
}
